// import Blog_Author from "./Blog_Author";
// import Comment from "./Comment";
import Blog_Form from "./Blog_Form";
import img from "./assets/Cyber_Security.PNG";
import img2 from "./assets/Future_Technology.PNG";

export default function CardComponent() {
  return (
    <div className="w-full bg-[#0A0F1F]">
      <div className=" mx-auto">

        <div className="flex flex-wrap gap-6">
          {/* LEFT SECTION */}
          <div className="w-full lg:w-[100%] pt-20 lg:pt-20">

            {/* BLOG CARD */}
            <div className="shadow-lg  bg-[#111527]  rounded-lg overflow-hidden">

              {/* TOP IMAGE */}
              <img
                src={img}
                className="w-full h-[350px]  md:h-[1000px]"
                alt=""
              />

              <div className="p-6">

                {/* TITLE */}
                <h2 className="text-3xl font-semibold p-2 text-white">
                  Cybersecurity is the backbone of modern digital infrastructure.
                </h2>

                {/* META TOP 
                <div className="mt-5 text-gray-600">
                  <ul className="flex flex-wrap items-center space-x-[20px] list-none p-0 m-0">

                    
                    <li className="flex items-center">
                      <i className="bi bi-person text-[16px] mr-2 leading-none"></i>
                      <a className="text-[14px] no-underline" href="#">Ashish</a>
                    </li>

                    <li className="flex items-center">
                      <i className="bi bi-clock text-[16px] mr-2 leading-none"></i>
                      <a className="text-[14px] no-underline" href="#">Jan 1, 2022</a>
                    </li>

                    <li className="flex items-center">
                      <i className="bi bi-chat-dots text-[16px] mr-2 leading-none"></i>
                      <a className="text-[14px] no-underline" href="#">12 Comments</a>
                    </li>
                  </ul>
                </div>
                */}

                {/* PARAGRAPHS */}
                <p className="p-2 my-5 text-gray-400">
                  Every organization—whether small or enterprise-level—faces cyber threats like malware, ransomware, data theft, phishing attacks, and unauthorized access.
                </p>

                <p className="p-2 my-1 text-gray-400">
                  At Cybredge Pvt. Ltd., we help businesses build secure systems through advanced firewalls, real-time threat monitoring, penetration testing, and data encryption solutions.
                </p>

                {/* BLOCKQUOTE */}
                <blockquote className="relative overflow-hidden bg-black/20 p-[60px] text-center my-5 text-[20px] font-medium rounded-lg">
                  <div className="absolute left-0 top-[20px] bottom-[20px] w-[3px] bg-red-600"></div>
                  <p className="text-gray-300">
                    Secure your business before attackers target you. <br />
                    📩 Contact: <a className="text-red-700" href="#">cyber.edge@yandex.com</a>

                  </p>
                </blockquote>

                <h3 className="mt-4 font-semibold text-xl text-white">Our Key Capabilities </h3>

                <p className="text-gray-400">
                  •	Advanced Network & Endpoint Security<br></br>
                  •	24/7 Threat Detection & Response<br></br>
                  •	Penetration Testing & Vulnerability Assessment<br></br>
                  •	SOC & SIEM Monitoring
                </p>

                {/* INSIDE IMAGE */}
                <img
                  src={img2}
                  className="w-full h-[350px] md:h-[1000px]  rounded-lg my-5"
                  alt=""
                />

                <h3 className="mt-4 font-semibold text-3xl pl-2 text-white">
                  The world is moving fast — and so are we.
                </h3>

                <p className="text-gray-400 pl-2">
                  Cybredge invests in next-generation technologies like Quantum computing, AR/VR, IoT, and Autonomous AI to build future-oriented digital ecosystems. <br /> Innovation today defines leadership tomorrow.
                </p>

                {/* META BOTTOM */}
                <div className="pt-3 border-t border-gray-700/10">

                  {/* CATEGORY */}
                  <i className="bi bi-folder text-gray-600 pl-2"></i>
                  <ul className="inline text-[14px] pr-5 list-none">
                    <li className="inline-block">
                      <a className="text-gray-600 ml-2 no-underline hover:text-[#fd02fd] duration-300" href="#">
                        Business
                      </a>
                    </li>
                  </ul>

                  {/* TAGS */}
                  <i className="bi bi-tags text-gray-600"></i>

                  <ul className="inline text-[14px] list-none">

                    <li className="inline-block">
                      <a className="text-gray-600 ml-2 no-underline hover:text-[#fd02fd] duration-300" href="#">
                        Creative
                      </a>
                    </li>

                    <li className="inline-block relative  before:pr-2">
                      <a className="text-gray-600 ml-2 no-underline hover:text-[#fd02fd] duration-300" href="#">
                        Tips
                      </a>
                    </li>

                    <li className="inline-block relative  before:pr-2">
                      <a className="text-gray-600 ml-2 no-underline hover:text-[#fd02fd] duration-300" href="#">
                        Marketing
                      </a>
                    </li>
                  </ul>

                </div>

              </div>
            </div>

            {/* AUTHORS, COMMENTS, FORM */}
            {/* <Blog_Author /> */}
            {/* <Blog_Author />  */}
            {/* <Comment /> */}
            <Blog_Form />
          </div>
        </div>
      </div>
    </div>
  );
}